import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	projectReportBreadcrumb: {
		id: 'spa-apps-software-breadcrumbs.project.project-report-breadcrumb',
		defaultMessage: 'Reports',
		description: 'Breadcrumb to reports in a classic software project.',
	},
});
